import { ReactNode } from 'react';

export type BreadCrumb = {
  name: string;
  route: string;
};
export type PageContainerProps = {
  children: ReactNode;
  breadcrumbs?: BreadCrumb[];
  centerContent?: boolean;
};

export const PageContainer = (props: PageContainerProps) => {
  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="py-4 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
        {props.children}
      </div>
    </section>
  );
};
